import { Outlet, Navigate} from "react-router";
import { isLoggedIn } from "./MainLayout";
import MainLayout from '../components/MainLayout';
//import SingUp from '../pages/SingUp';
//import { isLoggedIn } from '../pages/SingUp';

const AuthLayout = () => {
    

    if(isLoggedIn) {
        return <Navigate to="/" replace/>
    }    
    return (
        <div>
        <h1> Auth Layouth </h1>
        <Outlet/>
        </div>

    );
};

export default AuthLayout;